import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TenentIdentifierInterceptor } from './auth/tenant-identifier/tenent-identifier.interceptor';
import { BnNgIdleService } from 'bn-ng-idle';
import { UserInactivityModule } from './includes/user-inactivity/user-inactivity-module';
import { LanguageSwitcherComponent } from './includes/language-switcher/language-switcher.component';
import { GlobalLanguageSwitcherComponent } from './includes/global-language-switcher/global-language-switcher.component';
import { SharedModule } from './shared/shared.module';
import { APP_BASE_HREF } from '@angular/common';
import { WindowService } from './core/window.service';

export function getBaseUrl(windowService: WindowService) {
  if (windowService.getDocumentRefrence().location.pathname !== '') {
    const path = windowService
      .getDocumentRefrence()
      .location.pathname?.split('/');
    if (path.length < 3) {
      alert('No domain name / Store found');
      return;
    }
    const domain = path[1];
    // const tenantName = sessionStorage.getItem('tenant');
    const store = path[2];
    let tableNumber = null;
    if (path.length > 3) {
      tableNumber = path[3];
    }

    if (tableNumber) {
      return '/'
        .concat(domain)
        .concat('/')
        .concat(store)
        .concat('/')
        .concat(tableNumber);
    } else {
      return '/'.concat(domain).concat('/').concat(store);
    }
  }
  return '';
}

@NgModule({
  declarations: [
    AppComponent,
    LanguageSwitcherComponent,
    GlobalLanguageSwitcherComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    UserInactivityModule,
    SharedModule,
  ],
  providers: [
    BnNgIdleService,
    { provide: APP_BASE_HREF, useFactory: getBaseUrl, deps: [WindowService] },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenentIdentifierInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
